<template>
	<v-dialog v-model="showOrderElsewhere" persistent max-width="900">
		<v-card>
			<v-card-title class="primary white--text title px-4">
				Order Elsewhere
			</v-card-title>
			<v-card-text>
				<div class="px-2 text-details">
					<p class="subheading mb-2">Please provide order details:</p>
					<v-textarea v-model="orderDetails" outline hide-details auto-grow></v-textarea>
				</div>
			</v-card-text>
			<v-card-actions class="px-4">
				<v-spacer></v-spacer>
				<div class="pb-3">
					<v-btn color="primary" :disabled="orderDetails === ''" medium @click="save()" class="mr-1">Save</v-btn>
					<v-btn medium @click="close()">Cancel</v-btn>
				</div>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);

export default {
  name: "OrderElsewhere",
  props: {
    showOrderElsewhere: { type: Boolean, required: true }
  },
  data () {
    return {
      orderDetails: ""
    }
  },
  ...mapOrderActions(["saveOrderElsewhere"]),
  methods: {
    close () {
      let vm = this;
      vm.orderDetails = "";
      vm.$emit("closeOrderElsewhere");
    },
    save () {
      let vm = this;
      vm.$emit("saveOrder", vm.orderDetails);
    }
  }
}
</script>

<style lang="scss" scoped>
.text-details {
  ::v-deep textarea {
    margin-top: 0px !important;
    padding: 15px 0 !important;
  }
}
</style>